<script setup lang="ts">
/**
 * Hint — small muted text. role="alert" when danger variant is used,
 * so screen readers announce errors immediately.
 */
type HintVariant = 'default' | 'danger' | 'inline';

withDefaults(defineProps<{ variant?: HintVariant }>(), { variant: 'default' });
</script>

<template>
  <p
    :class="['hint', { 'hint--danger': variant === 'danger', 'hint--inline': variant === 'inline' }]"
    :role="variant === 'danger' ? 'alert' : undefined"
  >
    <slot></slot>
  </p>
</template>
